import type { FC } from 'react';
import React from 'react';

import { LoadableLazy } from '@confluence/loadable';
import { expValEquals } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { useCreateSpaceStore } from './CreateSpaceStore.tsx';

const CreateSpaceDrawerLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CreateSpaceDrawer" */ './CreateSpaceDrawer.tsx'))
			.CreateSpaceDrawer,
});

const CreateSmartSpaceDrawerLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CreateSmartSpaceDrawer" */ '../SmartCreate/CreateSmartSpaceDrawer.tsx'
			)
		).CreateSmartSpaceDrawer,
});

export const ConditionalCreateSpaceDrawer: FC = () => {
	const [{ shouldRenderDrawer, showCreateSpaceDrawer, createSpaceButtonRef }, { closeDrawer }] =
		useCreateSpaceStore();
	const { isRovoEnabled } = useSessionData();

	if (!shouldRenderDrawer) {
		return null;
	}

	if (isRovoEnabled && expValEquals('cc_smart_space_create', 'isEnabled', true)) {
		return (
			<CreateSmartSpaceDrawerLoader
				isOpen={showCreateSpaceDrawer}
				onClose={closeDrawer}
				shouldReturnFocus={createSpaceButtonRef}
			/>
		);
	}

	return <CreateSpaceDrawerLoader />;
};
